var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDropdown(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "21px",
    height: "21px",
    viewBox: "0 0 17 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.5 7.15439L1.97046 0.350185C1.51969 -0.116728 0.788849 -0.116728 0.338078 0.350185C-0.112693 0.817098 -0.112693 1.57411 0.338078 2.04103L7.68381 9.64982C8.13458 10.1167 8.86542 10.1167 9.31619 9.64982L16.6619 2.04103C17.1127 1.57411 17.1127 0.817098 16.6619 0.350185C16.2112 -0.116728 15.4803 -0.116728 15.0295 0.350185L8.5 7.15439Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDropdown);
export default __webpack_public_path__ + "static/media/dropdown.86c6cf886d97fa9cc897fa70e5f3dca2.svg";
export { ForwardRef as ReactComponent };